import flatpickr from "flatpickr";

document.addEventListener('DOMContentLoaded', function() {

    // for publish date on:
    /**
     * 1.) announcement publish date
     * 2.) event start date
     */

    flatpickr('.standard-datetime', {
        altInput: true,
        altFormat: "d/m/Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        minuteIncrement: 15
    });

    // end date
    /**
     * 1. ) for event end date
     */
     flatpickr('.standard-datetime-end', {
        altInput: true,
        altFormat: "d/m/Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        minuteIncrement: 15,
        onOpen: function(selectedDateTime, dateTimeStr, instance){
            instance.config.minDate = document.getElementsByClassName('standard-datetime')[0].value;
        }
    });

});